module.exports = __webpack_public_path__ + "img/alarm-header.faa12c60.png";